import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=e61000d8&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61000d8",
  null
  
)

export default component.exports